import { Injectable } from '@angular/core';
import { BaseService } from '../../shared/services/base.service';
import { UserUrl } from '../../shared/urls/user.url';
import { PatientUrl } from '../../shared/urls/patient.url';
import { CompanyAccountUrl } from '../../shared/urls/company-account.url';

@Injectable()
export class UpdatePatientInformationService {
    constructor(public baseService: BaseService) {

    }

    getCountryList() {
        const url = UserUrl.GET_USER_COUNTRY_INIT;
        return this.baseService.getData(url);
    }

    getInit() {
        return this.baseService.getData(PatientUrl.PATIENT_INIT);
    }

    getParty() {
        return this.baseService.getData(CompanyAccountUrl.GET_COMPANY_ACCOUNT_INIT);
    }

    getTypeParty(): any[] {
        return [
            {
                id: 0,
                name: 'Individual'
            },
            {
                id: 1,
                name: 'Group'
            }
        ];
    }

    getSexData(): any[] {
        return [
            {
                id: 0,
                name: 'Male'
            },
            {
                id: 1,
                name: 'Female'
            }
        ];
    }

    addAccount(param) {
        return this.baseService.postData(PatientUrl.PATIENT_ADD, param);
    }

    getPatientDetail(id) {
        return this.baseService.getById(PatientUrl.PATIENT_GET, id);
    }

    updatePatient(id, param) {
        return this.baseService.update(PatientUrl.PATIENT_UPDATE.replace('{id}', id), param);
    }
}



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/pages/update-patient-information/update-patient-information.service.ts